module.exports = __webpack_public_path__ + "static/media/video_byttelyd.0fde3e99.mp4";